import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { AlertTriangle, ArrowRight } from "lucide-react";

export function CompanionWarnings() {
  const [conflicts, setConflicts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/companions/conflicts").then(({ data }) => setConflicts(data.conflicts)).catch(() => setConflicts([]));
  }, []);

  if (!conflicts.length) return null;

  return (
    <div className="bg-amber-50 dark:bg-amber-950/30 rounded-2xl border border-amber-200 dark:border-amber-900/50 p-5 sm:p-6 shadow-sm" data-testid="companion-warnings">
      <h2 className="font-display text-lg font-semibold mb-3 flex items-center gap-2 text-amber-800 dark:text-amber-300">
        <AlertTriangle className="h-5 w-5" /> Companion Warnings
        <span className="text-sm font-normal text-amber-700/70 dark:text-amber-400/70">({conflicts.length})</span>
      </h2>
      <div className="space-y-2.5">
        {conflicts.slice(0, 5).map((c, i) => (
          <div key={i} className="flex items-center gap-2 text-sm flex-wrap" data-testid="companion-conflict">
            <button onClick={() => navigate(`/sprouts/${c.plant_a.id}`)} className="font-medium hover:underline">{c.plant_a.name}</button>
            <span className="text-muted-foreground">✕</span>
            <button onClick={() => navigate(`/sprouts/${c.plant_b.id}`)} className="font-medium hover:underline">{c.plant_b.name}</button>
            {c.same_location ? (
              <span className="text-xs px-2 py-0.5 rounded-full bg-red-100 text-red-700 dark:bg-red-900/50 dark:text-red-300">Same spot: {c.plant_a.location}</span>
            ) : (
              <span className="text-xs text-muted-foreground">({c.plant_a.species} & {c.plant_b.species})</span>
            )}
          </div>
        ))}
      </div>
      <button onClick={() => navigate("/guides")} className="mt-3 text-sm text-amber-800 dark:text-amber-300 font-medium flex items-center gap-1 hover:underline">
        See companion guides <ArrowRight className="h-4 w-4" />
      </button>
    </div>
  );
}
